const state = {
	sources_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
